import { type CustomResolversContext } from '../types';

const UserManageLinkedAccounts = (
	_: any,
	args: { userId: string },
	context: CustomResolversContext,
	info: any,
) => {
	const { userId } = args;
	const url = `${context.url.stargateRoot}/users/${userId}/manage/linked-accounts`;
	return context
		.fetch(url)
		.then((res) => res.json())
		.then((data) => {
			return {
				google: Boolean(data && data.google && data.google.linked),
				microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
				apple: Boolean(data && data.apple && data.apple.linked),
				saml: Boolean(data && data.saml && data.saml.linked),
			};
		});
};

export default UserManageLinkedAccounts;
